module.exports = __webpack_public_path__ + "img/selected3-min.666337b8.png";